import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-block-cta-banner',
    templateUrl: './block-cta-banner.component.html',
    styleUrl: './block-cta-banner.component.scss',
    standalone: false,
})
export class BlockCtaBannerComponent extends BlockAbstractComponent implements OnInit {
    override ngOnInit() {
        super.ngOnInit();

        this.block.data.styleVariant ??= 'card-overlay';
    }

    getBackground() {
        if (this.block.data.useBgImage) {
            return `url(${this.block.data.image})`;
        }

        switch (this.block.data.bgFillColor) {
            case 'white':
                return 'white';

            case 'primary':
                return 'var(--color-primary)';

            case 'secondary':
                return 'var(--color-secondary)';

            case 'black':
                return 'var(--bs-black)';
        }

        return 'white';
    }

    parseImageUrl(url: string): string {
        return url.replace('/api/1.0/download', '/file');
    }
}
